import { Box, Card as MuiCard, CardContent, Grid, Link } from "@mui/material";
import React from "react";
import Typography from "@mui/material/Typography";
import { Card, legalCard, subscriptionCard, updateInfoCard } from "./NavbarCards";
import { Brief, SubscriberId } from "../../app/services/subscriberFeedbackApi";

interface FeedbackNavbarProps {
    brief?: Brief;
    subscriberId: SubscriberId;
}

export const FeedbackNavbar = ({ brief, subscriberId }: FeedbackNavbarProps) => {
    const NavbarCard = ({ card }: { card: Card }) => (
        <MuiCard
            sx={{
                ":hover": {
                    boxShadow: 10,
                },
            }}
        >
            <CardContent>
                <Box
                    sx={{ width: "320px", height: "160px" }}
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                    justifyContent={"center"}
                >
                    <Typography my={2} align={"center"} variant={"subtitle1"}>
                        {card?.title}
                    </Typography>
                    {card?.links?.map((link) => (
                        <Link key={link.key} href={link.href}>
                            {link.text}
                        </Link>
                    ))}
                </Box>
            </CardContent>
        </MuiCard>
    );

    return (
        <Grid container justifyContent="center" spacing={2} alignItems="center" data-testid="help-links">
            <Grid item>
                <NavbarCard card={subscriptionCard(brief, subscriberId)} />
            </Grid>
            <Grid item>
                <NavbarCard card={updateInfoCard(brief, subscriberId)} />
            </Grid>
            <Grid item>
                <NavbarCard card={legalCard()} />
            </Grid>
        </Grid>
    );
};
